{
	"ariaContinueWithoutPreset": "Continue Without Preset",
	"ariaUploadPreset": "Upload Preset",
	"continueWithoutPreset": "Continue Without Preset",
	"unableToImportPresetPlease": "Unable to import preset. Please try another file.",
	"unableToImportPresetPlease2": "Unable to import preset. Please try another file.",
	"uploadDescription": "If you used a Lightroom preset, you can upload it to help the AI better match your editing style. If you don't have a preset, AI Color Match will be used to create your style.",
	"uploadPreset": "Upload Preset"
}
